import React, { useState, useEffect } from "react";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useHistory, useParams } from "react-router-dom";
import { getHistoryById } from "../utils/Actions";
import { isEmpty } from "lodash";
import { Loading } from "../atoms";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { saveAs } from "file-saver";
import { actualizarRegistro } from "../utils/Actions";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import moment from "moment";

const inintialState = {
  accountid: "",
  createAt: "",
  description: "",
  descriptionadmin: "",
  imagenes: [],
  title: "",
  user: "",
  userName: "",
};
export default function LogDetails() {
  const [state, setstate] = useState(inintialState);
  const [visible, setVisible] = useState(false);
  const [open, setopen] = useState(false);
  const [img, setimg] = useState("");
  const [accountlist, setaccountlist] = useState([]);
  let history = useHistory();
  let { id } = useParams();
  const incidentsid = id.slice(4);

  const account = localStorage.getItem("Account");
  const accountJSON = JSON.parse(account);
  const { rol, accountAsigned, accountAsignedName } = accountJSON[0];
  console.log(accountJSON);

  useEffect(() => {
    (async () => {
      console.log(incidentsid);
      //setstate(await getIncidentsById(incidentsid).data);
      const { data } = await getHistoryById(incidentsid);
      setstate(data);
      console.log(data);
    })();
  }, []);

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  const handleClose = () => {
    setopen(false);
  };

  const downloadimage = () => {
    saveAs(`${img}.jpg`, "image.jpg");
  };

  const save = async () => {
    const {
      accountid,
      createAt,
      description,
      descriptionadmin,
      imagenes: [],
      title,
      user,
      userName,
    } = state;

    if (isEmpty(title)) {
      alert("Debe ingresar un título");
    } else if (isEmpty(description)) {
      alert("Favor, no borre el valor de descripción");
    } else {
      setVisible(true);
      const data = {
        title,
        description,
        descriptionadmin,
        updatedAt: new Date(),
        updatedBy: `${account[0].name} ${account[0].lastname}`,
        status: 1,
      };
      const { statusresponse } = await actualizarRegistro(
        "Incidents",
        incidentsid,
        data
      );
      if (statusresponse) {
        alert("Actualización éxitosa");
      } else {
        alert(
          "Ha ocurrido un error al actualizar datos, favor inténtelo nuevamente"
        );
      }
      setVisible(false);
      history.push("/incidents");
    }
  };

  return (
    <FormControl
      style={{
        backgroundColor: "#fff",
        borderRadius: 5,
        padding: 20,
        paddingBottom: 30,
        width: "100%",
      }}
    >
      <Typography gutterBottom variant="h5">
        <IconButton>
          <ChevronLeftIcon onClick={() => history.goBack()} />
        </IconButton>
        Bitácora
      </Typography>

      <Grid
        xs={12}
        direction="column"
        justify="center"
        alignItems="center"
        container
        spacing={0}
        style={{ marginBottom: 20 }}
      >
        <Avatar src={state.userphoto} style={{ width: 100, height: 100 }} />
        {state && <span style={{ fontSize: 20 }}>{state.userName}</span>}
        {state && <span>{moment(state.createdAt).format("lll")}</span>}
      </Grid>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Título"
            variant="outlined"
            fullWidth
            name="title"
            onChange={onChange}
            onSubmit={() => {
              console.log("salio");
            }}
            value={state.title}
            fullWidth
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Descripción"
            variant="outlined"
            fullWidth
            name="description"
            onChange={onChange}
            value={state.description}
            fullWidth
            multiline={true}
            rows={3}
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          {state.imagenes && (
            <GridList cols={3}>
              {state.imagenes.map((image) => (
                <GridListTile key={image} cols={1}>
                  <img
                    src={image}
                    onClick={() => {
                      setopen(true);
                      setimg(image);
                    }}
                  />
                </GridListTile>
              ))}
            </GridList>
          )}
        </Grid>
      </Grid>
      <Loading visible={visible} setVisible={setVisible} />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Imagen</DialogTitle>
        <DialogContent>
          {/*<DialogContentText>
            To subscribe to this website, please enter your email address here.
            We will send updates occasionally.
           </DialogContentText>*/}
          <img src={img} style={{ width: 300, height: 300 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cerrar
          </Button>
          <Button onClick={downloadimage} color="primary">
            Descargar
          </Button>
        </DialogActions>
      </Dialog>
    </FormControl>
  );
}
